import { render, staticRenderFns } from "./SalesComparison.vue?vue&type=template&id=4c194d7f&"
import script from "./SalesComparison.vue?vue&type=script&lang=js&"
export * from "./SalesComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports